import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { MonthlyPerformanceResponseSchema } from "../schemas/dashboardV2Schemas";

const API_VERSION = 'v4';

const useDashboardMonthlyPerformance = (property_id?: string, year?: string | number) => {
    return useQuery({
        queryKey: ['dashboard-monthly-performance', property_id, year],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/dashboard/performance/monthly`, {
                params: { property_id, year }
            });
            const validationResult = MonthlyPerformanceResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Monthly Performance data format");
            }
            return validationResult.data;
        },
        enabled: !!property_id && !!year,
        retry: import.meta.env.VITE_MAX_RETRY ? parseInt(import.meta.env.VITE_MAX_RETRY as string) : 1,
        refetchOnWindowFocus: false
    });
};

export default useDashboardMonthlyPerformance;
